import { render } from "./Header.vue?vue&type=template&id=1ff6007a&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=1ff6007a&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff6007a"]])

export default __exports__